export class Header {
  private element: HTMLElement;
  private toggleButton: HTMLElement | null;
  private mobileNav: HTMLElement | null;
  private isOpen: boolean = false;

  constructor(element: HTMLElement) {
    this.element = element;
    this.toggleButton = element.querySelector("[data-mobile-toggle]");
    this.mobileNav = element.querySelector("[data-mobile-nav]");
    this.init();
  }

  private init(): void {
    if (!this.toggleButton || !this.mobileNav) return;

    this.toggleButton.addEventListener("click", () => this.toggleMobileNav());

    // Close mobile nav when clicking a link
    this.mobileNav.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;
      if (target.tagName === "A") {
        this.closeMobileNav();
      }
    });

    // Close mobile nav on escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.closeMobileNav();
      }
    });
  }

  private toggleMobileNav(): void {
    if (this.isOpen) {
      this.closeMobileNav();
    } else {
      this.openMobileNav();
    }
  }

  private openMobileNav(): void {
    if (!this.mobileNav || !this.toggleButton) return;
    this.mobileNav.classList.add("is-open");
    this.toggleButton.classList.add("is-open");
    this.isOpen = true;
    document.body.style.overflow = "hidden";
  }

  private closeMobileNav(): void {
    if (!this.mobileNav || !this.toggleButton) return;
    this.mobileNav.classList.remove("is-open");
    this.toggleButton.classList.remove("is-open");
    this.isOpen = false;
    document.body.style.overflow = "";
  }
}
